"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var markdown_it_1 = __importDefault(require("markdown-it"));

exports.decodeEntities = function (encodedString) {
  var maxLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 140;
  var shouldTruncate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var md = new markdown_it_1.default({
    html: true
  });

  if (encodedString) {
    var newStr = encodedString.replace(/\\n/g, "<br />"); // if (shouldTruncate) {
    //   const caret = newStr.length > maxLimit ? "..." : "";
    //   newStr = newStr.substr(0, maxLimit) + caret;
    // }

    var textArea = document.createElement("textarea");
    textArea.innerHTML = newStr;
    var val = textArea.value;
    var markdownOutput = md.render(val);

    if (shouldTruncate) {
      var caret = markdownOutput.length > maxLimit ? "..." : "";
      return markdownOutput.substr(0, maxLimit) + caret;
    }

    return markdownOutput;
  }

  return encodedString;
};

exports.LightenDarkenColor = function (col, amt) {
  var usePound = false;

  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) r = 255;else if (r < 0) r = 0;
  var b = (num >> 8 & 0x00ff) + amt;
  if (b > 255) b = 255;else if (b < 0) b = 0;
  var g = (num & 0x0000ff) + amt;
  if (g > 255) g = 255;else if (g < 0) g = 0;
  return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
};